'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-result-bar {\n  display: flex;\n  margin-bottom: 25px;\n  margin-top: 50px; }\n  @media (min-width: 768px) {\n    .varta-result-bar {\n      margin-bottom: 50px; } }\n  .varta-result-bar__title {\n    margin: 0; }\n  .varta-result-bar__link {\n    margin-left: 20px;\n    white-space: nowrap;\n    position: relative;\n    top: -4px;\n    align-self: flex-start; }\n  .varta-result-bar__wrapper {\n    margin-right: auto; }\n";
styleInject_es(css_248z);
